import { ActionTypes } from '../actionTypes';
import { GoalAnalyticsData, QueryData } from '../../types';

export const fetchCompletionsVsSendsRequest = (queryData: QueryData) => ({
  type: ActionTypes.FETCH_COMPLETIONS_VS_SENDS_METRICS_REQUEST,
  queryData,
});

export const fetchCompletionsVsSendsResponse = (metrics: GoalAnalyticsData) => ({
  type: ActionTypes.FETCH_COMPLETIONS_VS_SENDS_METRICS_RESPONSE,
  payload: metrics,
});

export const fetchCompletionsVsSendsError = () => ({
  type: ActionTypes.FETCH_COMPLETIONS_VS_SENDS_METRICS_ERROR,
});
